import { DEFAULT_VISIBLE_COLUMNS } from '@app/data/manageLists/listAttributes';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface TableConfigType {
  size: 'large' | 'middle' | 'small';
}

export interface ManageListsState {
  page: number;
  loadedTableData?: {
    totalCount?: number;
  },
  list: {
    itemsPerPage: number;
    selectedRowsUuids: string[];
    visibleColumns: string[];
    tableConfig: TableConfigType;
  }
}

const initialState: ManageListsState = {
  page: 1,
  list: {
    itemsPerPage: 10,
    visibleColumns: DEFAULT_VISIBLE_COLUMNS,
    selectedRowsUuids: [],
    tableConfig: {
      size: 'large',
    },
  },
};

export const manageListsSlice = createSlice({
  name: 'manageLists',
  initialState: { ...initialState },
  reducers: {
    updateItemsPerPage: (state, action: PayloadAction<number>) => {
      state.list.itemsPerPage = action.payload;
    },
    updateCurrentPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    resetCurrentPage: (state) => {
      state.page = initialState.page;
    },
    updateTableConfig: (state, action: PayloadAction<Partial<TableConfigType>>) => {
      state.list.tableConfig = {
        ...state.list.tableConfig,
        ...action.payload,
      };
    },
    updateSelectedRows: (state, action: PayloadAction<string[]>) => {
      state.list.selectedRowsUuids = action.payload;
    },
    setVisibleColumns: (state, action: PayloadAction<string[]>) => {
      state.list.visibleColumns = action.payload;
    },
    setLoadedTableData: (state, action: PayloadAction<{
      totalCount?: number;
    }>) => {
      state.loadedTableData = action.payload;
    },
  },
});

export const {
  updateItemsPerPage,
  updateCurrentPage,
  updateSelectedRows,
  resetCurrentPage,
  updateTableConfig,
  setVisibleColumns,
  setLoadedTableData,
} = manageListsSlice.actions;

export default manageListsSlice.reducer;
